import { Box, Button, styled } from "@mui/material";
import React from "react";
import { ConjunctionOption, TypedMap } from "react-awesome-query-builder";

interface ConjsProps {
  conjunctionOptions?: TypedMap<ConjunctionOption>;
  disabled?: boolean | undefined;
  readonly?: boolean | undefined;
  setConjunction?: ((conj: string) => void) | undefined;
}

const ConjunctionsButtonSC = styled(Button)<{ checked: boolean }>(({ theme, checked }) => {
  return {
    minWidth: "auto",
    borderRadius: 0,
    height: "auto",
    padding: "8px 12px",
    color: "#000",
    textTransform: "none",
    fontWeight: 600,
    fontFamily: "var(--copytext-font-family)",
    fontSize: 12,
    border: "1px solid #ccc",
    marginRight: "4px",
    backgroundColor: checked ? "var(--primary-color) !important" : "var(--color-steel-200)",
    "&:hover": {
      backgroundColor: checked ? "var(--primary-color)" : "var(--color-steel-300)",
    },
  };
});

const ConjunctionsWidget = ({ disabled, readonly, conjunctionOptions, setConjunction }: ConjsProps) => {
  return (
    <Box sx={{ display: disabled ?? readonly ? "none" : "flex", gap: "4px", alignItems: "center" }}>
      {Object.values(conjunctionOptions ?? {})?.map((conjunction) => (
        <ConjunctionsButtonSC
          checked={conjunction.checked}
          onClick={() => setConjunction?.(conjunction.key)}
          variant="contained"
          disableElevation
          disableFocusRipple
          disableTouchRipple
          key={conjunction.id}
        >
          {conjunction.label}
        </ConjunctionsButtonSC>
      ))}
    </Box>
  );
};

export default ConjunctionsWidget;
